<template>
    <b-list-group class="block__objectiveResume">
      <b-list-group-item v-for="(list,index) in lists" :key="index" :class="putTheRightClass(list.target)">
        <div class="icon">
          <span>
            <font-awesome-icon :icon="['far', list.icon]" />
          </span>                  
        </div>
        <div>
          <div class="left">
            <div class="number">
              <PuSkeleton :loading="isLoading" :count="1" width='120px'>                              
                {{list.number}}
              </PuSkeleton>
            </div>
            <div class="title">
              <PuSkeleton :loading="isLoading" :count="1" width='120px'>
                {{list.title}}
              </PuSkeleton>
            </div>
          </div>
          <PuSkeleton :loading="isLoading" :count="1" width='20px'>            
            <div class="target">
                {{list.target}}
            </div>
          </PuSkeleton>
        </div>
      </b-list-group-item>
    </b-list-group>
</template>


<script>
import Utils from "../../Utils"
import { mapGetters } from 'vuex'
//
export default {
  name: "ListObjectiveResume",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getListsObjectiveResume'
      ])
    },  
  props:{
    // lists:{
    //   type:Object
    // }
  },
  data(){
    return { 
      lists:"",
      isLoading:true,
    }
  },   
  methods : {
    putTheRightClass (target){
      return Utils.getTheClass(target);
    },
  },  
  mounted (){
  },
  created(){
    this.lists = this.getListsObjectiveResume;
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }  
}
</script>